import { render, staticRenderFns } from "./orderBook.vue?vue&type=template&id=8abf3f60&scoped=true&"
import script from "./orderBook.vue?vue&type=script&lang=js&"
export * from "./orderBook.vue?vue&type=script&lang=js&"
import style0 from "./orderBook.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderBook.vue?vue&type=style&index=1&id=8abf3f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abf3f60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDataTable,VPagination,VTextField})
